import firebase, { firestore } from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/firebase-storage'
import 'firebase/functions'

const ENV = process.env;

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: ENV.VUE_APP_FIREBASE_API_KEY,
  authDomain: ENV.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: ENV.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: ENV.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: ENV.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: ENV.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: ENV.VUE_APP_FIREBASE_APP_ID,
  measurementId: ENV.VUE_APP_FIREBASE_MEASUREMENT_ID
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const auth = firebase.auth();
const db = firebase.firestore();
const FieldValue = firestore.FieldValue;
const cloudFunction = firebase.functions();
const storage = firebase.storage().ref();
export default db;
export { auth, FieldValue, storage, cloudFunction }